export default function prettyLicensePlate(number) {
  if(isNaN(number[0])){
    return `${number[0] ? number[0] : ''} ${number[1] ? number[1] : ''}${number[2] ? number[2] : ''}${number[3] ? number[3] : ''} ${number[4] ? number[4] : ''}${number[5] ? number[5] : ''} ${number[6] ? number[6] : ''}${number[7] ? number[7] : ''}${number[8] ? number[8] : ''}`
  } else {
    return `${number[0] ? number[0] : ''}${number[1] ? number[1] : ''}${number[2] ? number[2] : ''}${number[3] ? number[3] : ''} ${number[4] ? number[4] : ''}${number[5] ? number[5] : ''} ${number[6] ? number[6] : ''}${number[7] ? number[7] : ''}${number[8] ? number[8] : ''}`
  }
}
